import _ from 'lodash'
;(function () {
  function setCustomCSSViewportHeight() {
    const vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  }

  window.addEventListener('resize', _.debounce(setCustomCSSViewportHeight, 100))
  setCustomCSSViewportHeight()
})()
